import { createReducer, on } from '@ngrx/store';
import * as TerminalRegistrationActions from './terminal-registration.action';
import {
  handleFailure,
  handleRequest,
  handleSuccess,
} from '../../../../shared/ngrx-factory/factory.reducer';

const initialRequestState: TerminalRegistrationActions.RequestState<any> = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialTerminalRegistrationState: TerminalRegistrationActions.TerminalRegistrationState =
  {
    initiateRegistration: { ...initialRequestState },
    terminalRegistrationProgress: { ...initialRequestState },
    addTerminalDetails: { ...initialRequestState },
    fetchEwuraLicence: { ...initialRequestState },
    addEwuraLicense: { ...initialRequestState },
    fetchLgaLicence: { ...initialRequestState },
    addLgaLicense: { ...initialRequestState },
    submitTerminalApplication: { ...initialRequestState },
    generateControlNumber: { ...initialRequestState },
    removeTerminalTank: { ...initialRequestState },
  };

export const terminalRegistrationReducer = createReducer(
  initialTerminalRegistrationState,

  on(TerminalRegistrationActions.TerminalInitiateActions.request, (state) =>
    handleRequest(state, 'initiateRegistration'),
  ),
  on(TerminalRegistrationActions.TerminalInitiateActions.success, (state, { response }) =>
    handleSuccess(state, 'initiateRegistration', response),
  ),
  on(TerminalRegistrationActions.TerminalInitiateActions.failure, (state, { error }) =>
    handleFailure(state, 'initiateRegistration', error),
  ),

  on(TerminalRegistrationActions.TerminalProgressActions.request, (state) =>
    handleRequest(state, 'terminalRegistrationProgress'),
  ),
  on(TerminalRegistrationActions.TerminalProgressActions.success, (state, { response }) =>
    handleSuccess(state, 'terminalRegistrationProgress', response),
  ),
  on(TerminalRegistrationActions.TerminalProgressActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalRegistrationProgress', error),
  ),

  on(TerminalRegistrationActions.TerminalAddDetailsActions.request, (state) =>
    handleRequest(state, 'addTerminalDetails'),
  ),
  on(TerminalRegistrationActions.TerminalAddDetailsActions.success, (state, { response }) =>
    handleSuccess(state, 'addTerminalDetails', response),
  ),
  on(TerminalRegistrationActions.TerminalAddDetailsActions.failure, (state, { error }) =>
    handleFailure(state, 'addTerminalDetails', error),
  ),

  on(TerminalRegistrationActions.TerminalFetchEwuraLicenceActions.request, (state) =>
    handleRequest(state, 'fetchEwuraLicence'),
  ),
  on(TerminalRegistrationActions.TerminalFetchEwuraLicenceActions.success, (state, { response }) =>
    handleSuccess(state, 'fetchEwuraLicence', response),
  ),
  on(TerminalRegistrationActions.TerminalFetchEwuraLicenceActions.failure, (state, { error }) =>
    handleFailure(state, 'fetchEwuraLicence', error),
  ),

  on(TerminalRegistrationActions.TerminalAddEwuraLicenseActions.request, (state) =>
    handleRequest(state, 'addEwuraLicense'),
  ),
  on(TerminalRegistrationActions.TerminalAddEwuraLicenseActions.success, (state, { response }) =>
    handleSuccess(state, 'addEwuraLicense', response),
  ),
  on(TerminalRegistrationActions.TerminalAddEwuraLicenseActions.failure, (state, { error }) =>
    handleFailure(state, 'addEwuraLicense', error),
  ),

  on(TerminalRegistrationActions.TerminalFetchLgaLicenceActions.request, (state) =>
    handleRequest(state, 'fetchLgaLicence'),
  ),
  on(TerminalRegistrationActions.TerminalFetchLgaLicenceActions.success, (state, { response }) =>
    handleSuccess(state, 'fetchLgaLicence', response),
  ),
  on(TerminalRegistrationActions.TerminalFetchLgaLicenceActions.failure, (state, { error }) =>
    handleFailure(state, 'fetchLgaLicence', error),
  ),

  on(TerminalRegistrationActions.TerminalAddLgaLicenseActions.request, (state) =>
    handleRequest(state, 'addLgaLicense'),
  ),
  on(TerminalRegistrationActions.TerminalAddLgaLicenseActions.success, (state, { response }) =>
    handleSuccess(state, 'addLgaLicense', response),
  ),
  on(TerminalRegistrationActions.TerminalAddLgaLicenseActions.failure, (state, { error }) =>
    handleFailure(state, 'addLgaLicense', error),
  ),

  on(TerminalRegistrationActions.TerminalSubmitApplicationActions.request, (state) =>
    handleRequest(state, 'submitTerminalApplication'),
  ),
  on(TerminalRegistrationActions.TerminalSubmitApplicationActions.success, (state, { response }) =>
    handleSuccess(state, 'submitTerminalApplication', response),
  ),
  on(TerminalRegistrationActions.TerminalSubmitApplicationActions.failure, (state, { error }) =>
    handleFailure(state, 'submitTerminalApplication', error),
  ),

  on(TerminalRegistrationActions.TerminalGenerateControlNumberActions.request, (state) =>
    handleRequest(state, 'generateControlNumber'),
  ),
  on(
    TerminalRegistrationActions.TerminalGenerateControlNumberActions.success,
    (state, { response }) => handleSuccess(state, 'generateControlNumber', response),
  ),
  on(TerminalRegistrationActions.TerminalGenerateControlNumberActions.failure, (state, { error }) =>
    handleFailure(state, 'generateControlNumber', error),
  ),

  on(TerminalRegistrationActions.TerminalRemoveTerminalTankActions.request, (state) =>
    handleRequest(state, 'removeTerminalTank'),
  ),
  on(TerminalRegistrationActions.TerminalRemoveTerminalTankActions.success, (state, { response }) =>
    handleSuccess(state, 'removeTerminalTank', response),
  ),
  on(TerminalRegistrationActions.TerminalRemoveTerminalTankActions.failure, (state, { error }) =>
    handleFailure(state, 'removeTerminalTank', error),
  ),

  on(TerminalRegistrationActions.clearTerminalRegistrationResponse, (state) => ({
    ...state,
    initiateRegistration: { ...initialTerminalRegistrationState.initiateRegistration },
    terminalRegistrationProgress: {
      ...initialTerminalRegistrationState.terminalRegistrationProgress,
    },
    addTerminalDetails: { ...initialTerminalRegistrationState.addTerminalDetails },
    fetchEwuraLicence: { ...initialTerminalRegistrationState.fetchEwuraLicence },
    addEwuraLicense: { ...initialTerminalRegistrationState.addEwuraLicense },
    fetchLgaLicence: { ...initialTerminalRegistrationState.fetchLgaLicence },
    addLgaLicense: { ...initialTerminalRegistrationState.addLgaLicense },
    submitTerminalApplication: { ...initialTerminalRegistrationState.submitTerminalApplication },
    generateControlNumber: { ...initialTerminalRegistrationState.generateControlNumber },
    removeTerminalTank: { ...initialTerminalRegistrationState.removeTerminalTank },
  })),

  // Update bills on terminalRegistrationRequest within getTerminalRegistrationProgress
  on(
    TerminalRegistrationActions.updateRegistrationSummaryBill,
    (state, { summary, billResponse }) => {
      const progress = state.terminalRegistrationProgress?.response;
      if (!progress?.data?.data?.terminalRegistrationRequest) return state;

      const updated = {
        ...progress,
        data: {
          ...progress.data,
          data: {
            ...progress.data.data,
            terminalRegistrationRequest: {
              ...progress.data.data.terminalRegistrationRequest,
              bills: billResponse?.bills ?? [],
            },
          },
        },
      };

      return {
        ...state,
        terminalRegistrationProgress: {
          ...state.terminalRegistrationProgress,
          response: updated,
        },
      };
    },
  ),
);
